import { LeafletMap, Marker } from './LeafletMap'
import { Style } from 'inlines'

export type SingleMarkerMapProps = Marker & {
  zoom?: number
  height?: string
  style?: Style
}

export const SingleMarkerMap = ({
  lat,
  long,
  marker,
  zoom,
  height,
  style,
}: SingleMarkerMapProps) => {
  return (
    <LeafletMap
      markers={[{ lat, long, marker }]}
      zoom={zoom}
      height={height}
      style={style}
    />
  )
}
